import React from 'react';

const AuthenticationTabs = ({ activeTab, onTabChange }) => {
  return (
    <div className="flex border-b border-border mb-6">
      <button
        type="button"
        onClick={() => onTabChange('login')}
        className={`flex-1 px-6 py-3 text-sm font-medium transition-all duration-200 ${
          activeTab === 'login' ?'text-primary border-b-2 border-primary' :'text-muted-foreground hover:text-foreground'
        }`}
      >
        Sign In
      </button>
      <button
        type="button"
        onClick={() => onTabChange('register')}
        className={`flex-1 px-6 py-3 text-sm font-medium transition-all duration-200 ${
          activeTab === 'register' ?'text-primary border-b-2 border-primary' :'text-muted-foreground hover:text-foreground'
        }`}
      >
        Register
      </button>
    </div>
  );
};

export default AuthenticationTabs;